import { RootState } from '@/store/types'
import { ActionContext } from 'vuex'
import studio, { AdminDocNames, CollectionNames } from '@/modules/database/utils'
import { defineModule } from 'direct-vuex'
import { moduleActionContext } from '@/store'
import { Olympics } from '../classes'

// Store module components
type OlympicsContext = ActionContext<Olympics, RootState>

const state = {
  startDate: null, redirectURL: null, athleteMomentBaseUrl: null
} as Olympics

const getters = {
}

const actions = {
  async subscribeOlympics (context: OlympicsContext) {
    const { commit } = olympicsModuleActionContext(context)
    const result = await studio.subscriptions.subscribe({
      key: 'olympics',
      query: studio.db.collection(CollectionNames.ADMIN).doc(AdminDocNames.OLYMPICS),
      callback: commit.updateOlympics
    })
    result.logIfError('subscribeOlympics')
  },
  unsubscribeOlympics (context: OlympicsContext) {
    const { commit } = olympicsModuleActionContext(context)
    studio.subscriptions.unsubscribe('olympics', commit.cleanup)
  },
  cleanup (context: OlympicsContext) {
    const { commit } = olympicsModuleActionContext(context)
    commit.cleanup()
  },
  async getOlympicsData (): Promise<Olympics> {
    const result = await studio.db.collection(CollectionNames.ADMIN).doc(AdminDocNames.OLYMPICS).get()
    if (result.isFailure) {
      console.error('Could not fetch Olympics config', result.error)
      return new Olympics({})
    }
    return new Olympics(result.value)
  }
}

const mutations = {
  updateOlympics (state: Olympics, olympics: Olympics) {
    state.athleteMomentBaseUrl = olympics.athleteMomentBaseUrl
    state.redirectURL = olympics.redirectURL
    state.startDate = olympics.startDate
  },
  cleanup (state: Olympics) {
    state.athleteMomentBaseUrl = null
    state.redirectURL = null
    state.startDate = null
  }
}

const olympicsModule = defineModule({
  namespaced: true,
  state,
  getters,
  mutations,
  actions
})

export default olympicsModule
export const olympicsModuleActionContext = (context: OlympicsContext) =>
  moduleActionContext(context, olympicsModule)
